import { AbstractViewModel } from '../../../abstract.view.model';
import { ScreeningItemApiModel } from '../../../api-model/order/screening-item/screening-item.api.model';
import { ScreeningItemExtraFeeViewModel } from './screening-item-extra-fee.view.model';
import { ScreeningItemMembershipPriceViewModel } from './screening-item-membership-price.view.model';

export class ScreeningItemViewModel extends AbstractViewModel<ScreeningItemApiModel> {
  id: string;
  seatId: string;
  screeningId: string;
  ticketId: string;
  price: number;
  ticketPrice: number;
  quantity: number;
  tax: number;
  extraFees: ScreeningItemExtraFeeViewModel[] = [];
  bookingId: string;
  cardId: string;
  optionalExtraFees: string[] = [];
  name: string;
  printoutName: string;
  voucherNumber: string;
  voucherName: string;
  defaultPriceLevelPrice: number;
  ticketDefaultPriceLevelPrice: number;
  itemEarnedPoints: number;
  itemRedemptionPoints: number;
  promotionId: string;
  promotionName: string;

  // customFields
  row: string;
  seat: string;
  group: string;
  ticket: any;
  membershipPrices: ScreeningItemMembershipPriceViewModel[] = [];

  constructor(apiModel: ScreeningItemApiModel = new ScreeningItemApiModel()) {
    super(apiModel);
    this.fromApiModel();
  }

  protected fromApiModel(): void {
    this.id = this.apiModel.id;
    this.seatId = this.apiModel.seatId;
    this.screeningId = this.apiModel.screeningId;
    this.ticketId = this.apiModel.ticketId;
    this.price = this.apiModel.price;
    this.ticketPrice = this.apiModel.ticketPrice;
    this.quantity = this.apiModel.quantity;
    this.tax = this.apiModel.tax;
    this.extraFees = this.apiModel.extraFees ? this.apiModel.extraFees.map((extraFee) => new ScreeningItemExtraFeeViewModel(extraFee)) : [];
    this.bookingId = this.apiModel.bookingId;
    this.optionalExtraFees = this.apiModel.optionalExtraFees ? this.apiModel.optionalExtraFees.map((optionalExtraFee) => optionalExtraFee) : [];
    this.name = this.apiModel.name;
    this.printoutName = this.apiModel.printoutName;
    this.voucherNumber = this.apiModel.voucherNumber;
    this.voucherName = this.apiModel.voucherName;
    this.defaultPriceLevelPrice = this.apiModel.defaultPriceLevelPrice;
    this.ticketDefaultPriceLevelPrice = this.apiModel.ticketDefaultPriceLevelPrice;
    this.itemEarnedPoints = this.apiModel.itemEarnedPoints;
    this.itemRedemptionPoints = this.apiModel.itemRedemptionPoints;
    this.promotionId = this.apiModel.promotionId;
    this.promotionName = this.apiModel.promotionName;
    this.membershipPrices = this.apiModel.membershipPrices
      ? this.apiModel.membershipPrices.map((membershipPrice) => new ScreeningItemMembershipPriceViewModel(membershipPrice))
      : [];
  }

  toApiModel(): ScreeningItemApiModel {
    return Object.assign(this.apiModel, {
      id: this.id,
      seatId: this.seatId,
      screeningId: this.screeningId,
      ticketId: this.ticketId,
      quantity: this.quantity,
      extraFees: this.extraFees.map((extraFee) => extraFee.toApiModel()),
      optionalExtraFees: this.optionalExtraFees,
    });
  }

  hasVoucher() {
    return Boolean(this.voucherNumber) || Boolean(this.voucherName);
  }
}
